module.exports = __webpack_public_path__ + "img/hotel-6.17eb2ccc.jpeg";